import {SourcingVehicleListItemResponseBody} from '@dms/api/core';

import {SourcingType} from '../../../hooks/useSourcingType';
import {isCarvagoBuyBlockedBySuspiciousVehicle} from '../../../utils/isCarvagoBuyBlockedBySuspiciousVehicle';
import {isClassifiedsAdInactive} from '../../../utils/isClassifiedsAdInactive';

export type ClassifyCarvagoBuyRowsResult = {
  eligibleRows: SourcingVehicleListItemResponseBody[];
  skippedInactiveCount: number;
  hasBlockedVehicle: boolean;
};

/**
 * Partitions a bulk selection for Carvago Buy.
 * Inactive classifieds are skipped (dialog warning); suspicious vehicles block the whole action.
 */
export function classifyCarvagoBuyRows(
  selectedRows: SourcingVehicleListItemResponseBody[],
  sourcingType: SourcingType
): ClassifyCarvagoBuyRowsResult {
  const eligibleRows: SourcingVehicleListItemResponseBody[] = [];
  let skippedInactiveCount = 0;
  let hasBlockedVehicle = false;

  for (const vehicle of selectedRows) {
    if (vehicle.carvagoBuy) {
      continue;
    }

    // Skipped from the request; do not disable Carvago Buy for remaining eligible rows.
    if (
      sourcingType === SourcingType.CLASSIFIEDS &&
      isClassifiedsAdInactive(vehicle.sourcingVehicle)
    ) {
      skippedInactiveCount += 1;
      continue;
    }

    // Blocks the entire bulk Carvago Buy until the selection is clean.
    if (isCarvagoBuyBlockedBySuspiciousVehicle(vehicle.sourcingVehicle)) {
      hasBlockedVehicle = true;
      continue;
    }

    eligibleRows.push(vehicle);
  }

  return {eligibleRows, skippedInactiveCount, hasBlockedVehicle};
}
